import client from './client'
import install from './install'

// 子模块

import api from './api'
import apiAsync from './apiAsync'

export default class rootApi {
  constructor (options) {
    if (rootApi.instance) {
      throw new Error('rootApi is singleton')
    }
    rootApi.instance = this
    this.options = options

    client.defaults.baseURL = options.baseURL

    this.api = api
    this.apiAsync = apiAsync
  }

  static getInstance () {
    return rootApi.instance
  }
}

rootApi.instance = null
rootApi.install = install



// WEBPACK FOOTER //
// ./src/apis/root-api/index.js